(() => {
	class AnnouncementRotator extends HTMLElement {
		connectedCallback() {
			if (this.initialized) return;

			this.slides = this.querySelectorAll('[data-announcement-slide]');

			if (this.slides.length < 2) return;

			this.initialized = true;
			this.speed = parseInt(this.dataset.speed, 10) || 5000;
			this.pauseOnHover = this.dataset.pauseOnHover !== 'false';
			this.interval = null;
			this.isHoverPaused = false;
			this.isDocumentHidden = document.hidden;
			this.index = 0;

			this.slides.forEach((slide, slideIndex) => {
				if (slide.classList.contains('is-active')) {
					this.index = slideIndex;
				}
			});

			this.onEnter = this.pause.bind(this);
			this.onLeave = this.resume.bind(this);
			this.onVisibilityChange = this.handleVisibilityChange.bind(this);

			if (this.pauseOnHover) {
				this.addEventListener('mouseenter', this.onEnter);
				this.addEventListener('mouseleave', this.onLeave);
				this.addEventListener('focusin', this.onEnter);
				this.addEventListener('focusout', this.onLeave);
			}

			document.addEventListener('visibilitychange', this.onVisibilityChange);

			this.start();
		}

		disconnectedCallback() {
			this.stop();
			document.removeEventListener('visibilitychange', this.onVisibilityChange);
		}

		start() {
			this.stop();

			if (this.isHoverPaused || this.isDocumentHidden) return;

			this.interval = setInterval(this.rotate.bind(this), this.speed);
		}

		stop() {
			if (this.interval) {
				clearInterval(this.interval);
				this.interval = null;
			}
		}

		rotate() {
			const current = this.slides[this.index];

			if (current) {
				current.classList.remove('is-active');
			}

			this.index = (this.index + 1) % this.slides.length;

			const next = this.slides[this.index];

			if (next) {
				next.classList.add('is-active');
			}
		}

		pause() {
			this.isHoverPaused = true;
			this.stop();
		}

		resume() {
			this.isHoverPaused = false;
			this.start();
		}

		handleVisibilityChange() {
			this.isDocumentHidden = document.hidden;

			if (this.isDocumentHidden) {
				this.stop();
				return;
			}

			this.start();
		}
	}

	if (!customElements.get('announcement-rotator')) {
		customElements.define('announcement-rotator', AnnouncementRotator);
	}
})();
